<template>
	<div class="container_row">
		<div class="container_col">
			<div class="cell1_div">
				<h3>{{proDetail.name}}</h3>
				<label style="margin-left: 6.25rem;margin-right: 6.25rem;">项目id:{{proDetail.webId}}</label>
				<label>地点:{{proDetail.cityName}}</label>
			</div>
			<div class="text_div">授权站点：{{proDetail.webUrl}}</div>
			<div class="text_div">项目描述：{{proDetail.describe}}</div>
		</div>
		<div>
			<div class="op_div">
				<el-button type="text" @click="editProject(proDetail)" v-if="role === 0">编辑</el-button>
				<el-button type="text" @click="delProject(proDetail)" v-if="role === 0">删除</el-button>
			</div>
			<div>
				<el-button type="text" @click="createPage(proDetail)">落地页</el-button>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	export default {
		name:'projectcell',
		
		props:['proDetail', 'role'],
		
		data() {
			return {
				
			}
		},
		
		methods:{
			editProject(obj) {
				console.log('projectcell editProject')
				this.$emit('editAction', obj)
			},
			
			delProject(obj) {
				console.log('projectcell delProject')
				this.$emit('delAction', obj)
			},
			
			createPage(obj) {
				console.log('projectcell createPage obj = ', obj)
				this.$emit('toPage', obj)
			}
		}
	}
</script>

<style scoped="scoped">
	
	.container_col {
		width: 85%;
	}
	.cell1_div {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 90%;
		height: 2.5rem;
		justify-content: flex-start;
	}
	
	.text_div {
		width: 90%;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 0.3125rem;
	}
	
	.op_div {
		width: 10%;
		height: 100%;
		/* background-color: skyblue; */
		display: flex;
		justify-content: flex-start;
	}
	
</style>
